import { render, staticRenderFns } from "./AggregateInformation.vue?vue&type=template&id=a9404900&scoped=true&"
import script from "./AggregateInformation.vue?vue&type=script&lang=js&"
export * from "./AggregateInformation.vue?vue&type=script&lang=js&"
import style0 from "./AggregateInformation.vue?vue&type=style&index=0&id=a9404900&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9404900",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VImg})
